import styled from "@emotion/styled";
import React from "react";
import { Input, InputProps } from "./Input";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

export interface DatePickerProps extends InputProps {}

const StyledInput = styled(Input)`
  display: block;
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  min-height: 1.2em;

  ::-webkit-date-and-time-value {
    text-align: left;
  }
  ::-webkit-search-cancel-button,
  ::-webkit-clear-button {
    -webkit-appearance: none;
    color: hsl(var(--color-gray-900) / 0.54);
    cursor: pointer;
    height: 1.5rem;
    margin-right: 50px;
    width: 1.5rem;
  }
  ::-webkit-calendar-picker-indicator {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
    opacity: 0;
  }
  /* ::-webkit-inner-spin-button {
    display: none;
  } */
`;

const DatePicker = (props: DatePickerProps) => {
  const icon = <CalendarMonthIcon className="flex h-full items-center" />;
  return (
    <StyledInput
      type="date"
      icon={icon}
      pattern="\d{4}-\d{2}-\d{2}"
      required
      {...props}
    />
  );
};

export { DatePicker };
